import { render } from "./GamePointsView.vue?vue&type=template&id=6ca2e571"
import script from "./GamePointsView.vue?vue&type=script&lang=js"
export * from "./GamePointsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__